import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["ignoreUserThemeOverrides", "isLoading", "onClick", "presetId", "selected", "themePath"];
import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { buildPresetTilePreviewUrl } from '../../utils/urls';
import { View } from 'foundations-components/components/View';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { track } from '../../utils/standaloneUsageTracker';
import { EVENTS as StandaloneTrackingEventTypes } from '../../constants/usage/standaloneTracking';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Ribbon } from 'foundations-components/transitional/components/Ribbon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TileIframe = styled.iframe.withConfig({
  displayName: "PresetTile__TileIframe"
})(({
  theme
}) => {
  return `
    border-width: ${theme.borderWidth['0']};
    border-radius: ${theme.borderRadius['100']};
    width: 100%;
    height: 100%;
  `;
});
const PresetTile = _ref => {
  let {
      ignoreUserThemeOverrides = true,
      isLoading = false,
      onClick,
      presetId,
      selected,
      themePath
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const previewUrl = buildPresetTilePreviewUrl(themePath, presetId, ignoreUserThemeOverrides);
  return /*#__PURE__*/_jsxs(View, Object.assign({
    position: "relative"
  }, rest, {
    children: [selected && /*#__PURE__*/_jsx(Ribbon, {
      position: "left",
      insetBlockStart: "136px",
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "theme-previewer.themePresets.selected"
      })
    }), /*#__PURE__*/_jsx(SelectableBox, {
      "data-test-id": "preset-tile",
      "data-preset-id": presetId || 'default',
      type: "default",
      onClick: () => {
        track(StandaloneTrackingEventTypes.INTERACTION, {
          action: 'preset-selected'
        });
        onClick === null || onClick === void 0 || onClick();
      },
      inlineSize: "100%",
      padding: "200",
      selected: selected,
      children: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "small",
        grow: true
      }) : /*#__PURE__*/_jsxs(View, {
        blockSize: "145px",
        inlineSize: "320px",
        position: "relative",
        children: [/*#__PURE__*/_jsx(View, {
          blockSize: "100%",
          inlineSize: "100%",
          insetBlockStart: "0",
          insetInlineStart: "0",
          position: "absolute",
          zIndex: "1000"
        }), /*#__PURE__*/_jsx(TileIframe, {
          src: previewUrl || ''
        })]
      })
    })]
  }));
};
export default PresetTile;